module.exports = "<ng-content></ng-content>\n<div class=\"ic-card__content-action\">\n    <ng-content select=\"ic-navigation\"></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/card/card-content.component.html
// module id = ./src/app/layout/card/card-content.component.html
// module chunks = main